import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import {
  Button,
  Form,
  Grid,
  Header,
  Icon,
  Modal,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next'; // 1. Import withTranslation HOC
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import DateTimePicker from '../../components/DateTimePicker';

moment.locale('en-gb');

const inputDateFormat = 'DD/MM/YYYY, hh:mm A';

class DateTimeForm extends Component {
  static propTypes = {
    data: PropTypes.oneOfType([
      PropTypes.object,
    ]).isRequired,
    headerNode: PropTypes.node,
    descriptionNode: PropTypes.node,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    open: PropTypes.bool,
    scrolling: PropTypes.bool,
    t: PropTypes.func.isRequired, // 2. Add t function to propTypes
  }
  constructor(props) {
    super(props);
    const data = props.data || '';
    this.state = {
      data,
    };
  }
  componentWillReceiveProps(nextProps) {
    const data = nextProps.data || '';
    this.setState({
      data,
    });
  }
  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  handleOnComfirm = (e) => {
    e.preventDefault();
    let { data } = this.state;
    // remove timezone from date object (because API server has default timezone set)
    if (data) data = `${moment(data).format('YYYY-MM-DDTHH:mm:ss')}Z`;
    if (this.props.onConfirm) {
      this.props.onConfirm(e, data);
    }
  }
  handleOnClear = (e) => {
    e.preventDefault();
    let { data } = this.state;
    data = null;
    this.setState({ data });
  }
  handleOnChange = (value) => {
    let { data } = this.state;
    data = value;
    this.setState({ data });
  }
  render() {
    const { data } = this.state;
    const { t } = this.props;

    return (
      <Modal
        open={this.props.open}
        onClose={this.handleOnClose}
        size="tiny"
        closeOnDimmerClick={false}
      >
        <Header>
          <Icon name="calendar" />
          <Header.Content>
            {/* 4. Wrapped default string with t() */}
            {this.props.headerNode || t('Date Time', { ns: TRANSLATION_FILES.translation })}
            <Header.Subheader>{this.props.descriptionNode ? this.props.descriptionNode : ''}</Header.Subheader>
          </Header.Content>
        </Header>
        <Modal.Content scrolling={this.props.scrolling || false}>
          <Grid centered>
            <Grid.Row>
              <Grid.Column mobile={16} tablet={16} computer={2} className="small-hide tablet-hide" />
              <Grid.Column mobile={16} tablet={16} computer={12}>
                <div className="ui form">
                  <Form.Group widths="equal">
                    <Form.Input
                      fluid
                      label={this.props.label ? this.props.label : ''}
                      placeholder={this.props.placeholder ? this.props.placeholder : ''}
                      value={data ? moment(data).format(inputDateFormat) : ''}
                      readOnly
                    />
                  </Form.Group>
                  <DateTimePicker
                    closeable={false}
                    noPadding
                    onChange={value => this.handleOnChange(value)}
                    value={data ? moment(data).toDate() : ''}
                    visible
                  />
                </div>
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={2} className="small-hide tablet-hide" />
            </Grid.Row>
          </Grid>
        </Modal.Content>
        <Modal.Actions>
          {/* 5. Wrapped button text keys with t() */}
          <Button onClick={this.handleOnClose} icon="cancel" content={t('Cancel', { ns: TRANSLATION_FILES.translation })} />
          <Button color="blue" onClick={this.handleOnComfirm} icon="save" content={t('Save', { ns: TRANSLATION_FILES.translation })} />
        </Modal.Actions>
      </Modal>
    );
  }
}

// 6. Wrap the class export with the translation HOC
export default withTranslation(namespaces, { withRef: true })(DateTimeForm);



// WEBPACK FOOTER //
// ./src/containers/modals/DateTimeForm.jsx